import React, { Component } from 'react';
import { Switch, Redirect, Route, Link, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import './App.css';

import Login from './Login';
import Localization from './Localization';

const firebase = window.firebase;





class Home extends Component {

	componentDidMount() {
		console.log(firebase);
		// if (!isChecked)
		// setTimeout(()=>{
		//   this.props.history.push('/login')
		// }, 2000)
	}
	render(){
		return (
			<div className="container">
				<h1>Welcome to Bondora Localization</h1>
			</div>
		)
	}
}



class App extends Component {



	state = {
		user: ''
	}
	componentWillMount(){
		firebase.auth().onAuthStateChanged(
			user => { 
				console.log('current user: ', user); 
				if (user === null) {
					//setTimeout(()=>{
						//console.log(this.props); 
						//console.log('current user: ', user); 
						
						this.props.history.push('/login')
						//window.location.href = '/login';
					//}, 2000)
				} else {
					console.log('user', user)
					this.setState({user})
					this.props.history.push('/app');

					//setTimeout(()=>{
						//console.log('redirect localization'); 
						//history.push('/localization')
						//this.props.history.push('/localization')
						//window.location.href = '/localization';
					//}, 2000)
				}
				// if(!this.isChecked){
				// 	setTimeout(()=>{
				// 		this.props.history.push('/login')
				// 	}, 2000)
				// } else {
				// 	setTimeout(()=>{
				// 		this.props.history.push('/')
				// 	}, 2000)
				// }
				this.isChecked = true;
			}
		);
	}

	render() {
		const { user } = this.state;
		return (
			<div className="App">
				
				{user ? <div>{user.displayName}</div> : <h1>User Doesn't Exist</h1>}
				<Switch>
					<Route exact path="/" component={Home} />
					<Route path="/login" component={Login} />
					<Route path="/app" component={Localization} />
				</Switch>
			</div>
		);
	}
}

/*
<Route path="/login" component={Login}/>
<Route path="/app/home" component={Home}/>
<Redirect from="/" to="/login"/>*/

const mapStateToProps = (state) => {
	return { message: state }
}


const ConnectedApp = connect(mapStateToProps)(App);

export default withRouter(ConnectedApp);


// WEBPACK FOOTER //
// ./src/App.js